import React from "react";

const Spacer = props => {
	const {s} = props;

	return <div style={{width: `${s}px`}} />;
};

export default Spacer;